export default __webpack_public_path__ + "static/media/icon-empty.18469d1d.svg";